/**
 * Main JavaScript file
 */

import './video-trigger.js';

document.addEventListener('DOMContentLoaded', function() {
    console.log('WS Theme loaded');

    // Global throttled Locomotive update helper
    (function(){
        try {
            var scheduled = false;
            function locoUpdate(){
                if (scheduled) return;
                scheduled = true;
                requestAnimationFrame(function(){
                    scheduled = false;
                    try {
                        if (window.wsScroll && typeof window.wsScroll.update === 'function') {
                            window.wsScroll.update();
                        }
                    } catch (e) {}
                });
            }
            window.wsLocoUpdate = locoUpdate;
            // Optional: listen to custom mutation events from widgets
            window.addEventListener('ws:swiper-mutated', locoUpdate);
        } catch (e) {}
    })();
    // Offcanvas burger menu
    (function(){
        var burger = document.querySelector('.burger');
        var offcanvas = document.getElementById('offcanvas-menu');
        if (!burger || !offcanvas) return;

        function openMenu(){
            offcanvas.setAttribute('aria-hidden', 'false');
            burger.classList.add('is-active');
            burger.setAttribute('aria-expanded', 'true');
            try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
        }
        function closeMenu(){
            offcanvas.setAttribute('aria-hidden', 'true');
            burger.classList.remove('is-active');
            burger.setAttribute('aria-expanded', 'false');
            try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
        }
        function toggleMenu(){
            var hidden = offcanvas.getAttribute('aria-hidden') !== 'false';
            hidden ? openMenu() : closeMenu();
        }

        burger.addEventListener('click', toggleMenu);

        offcanvas.addEventListener('click', function(e){
            var target = e.target;
            if (!target) return;
            if (target.hasAttribute('data-offcanvas-close')) {
                closeMenu();
            }
        });

        document.addEventListener('keydown', function(e){
            if (e.key === 'Escape') closeMenu();
        });
    })();


    // Headroom integration
    // (function(){
    //     try {
    //         var header = document.querySelector('#masthead');
    //         if (!header) return;

    //         // When Locomotive is absent, use native Headroom if available
    //         if (window.Headroom && !window.LocomotiveScroll) {
    //             var headroom = new window.Headroom(header, {
    //                 tolerance: { up: 5, down: 0 },
    //                 offset: 80,
    //                 classes: {
    //                     initial: 'headroom',
    //                     pinned: 'headroom--pinned',
    //                     unpinned: 'headroom--unpinned',
    //                     top: 'headroom--top',
    //                     notTop: 'headroom--not-top',
    //                     bottom: 'headroom--bottom',
    //                     notBottom: 'headroom--not-bottom'
    //                 }
    //             });
    //             headroom.init();
    //             return;
    //         }

    //         // When Locomotive is present, emulate Headroom using its scroll events
    //         var attached = false;
    //         function attachToScroll(scroll){
    //             if (!scroll || typeof scroll.on !== 'function' || attached) return;
    //             attached = true;
    //             var lastY = 0;
    //             var ticking = false;
    //             var toleranceUp = 5;
    //             var toleranceDown = 0;
    //             var offset = 80;
    //             header.classList.add('headroom');

    //             function setState(state){
    //                 if (state === 'pinned') {
    //                     header.classList.add('headroom--pinned');
    //                     header.classList.remove('headroom--unpinned');
    //                 } else if (state === 'unpinned') {
    //                     header.classList.add('headroom--unpinned');
    //                     header.classList.remove('headroom--pinned');
    //                 }
    //             }

    //             function onScroll(data){
    //                 if (ticking) return;
    //                 ticking = true;
    //                 requestAnimationFrame(function(){
    //                     var y = data && typeof data.scroll === 'object' ? (data.scroll.y || 0) : 0;
    //                     var delta = y - lastY;
    //                     var absDelta = Math.abs(delta);

    //                     // Top/bottom states
    //                     var atTop = y <= 0;
    //                     header.classList.toggle('headroom--top', atTop);
    //                     header.classList.toggle('headroom--not-top', !atTop);

    //                     if (y < offset) {
    //                         // Before offset, keep pinned
    //                         setState('pinned');
    //                     } else {
    //                         if (delta > 0 && absDelta > toleranceDown) {
    //                             // Scrolling down
    //                             setState('unpinned');
    //                         } else if (delta < 0 && absDelta > toleranceUp) {
    //                             // Scrolling up
    //                             setState('pinned');
    //                         }
    //                     }

    //                     lastY = y;
    //                     ticking = false;
    //                 });
    //             }

    //             // Initial state
    //             setState('pinned');
    //             scroll.on('scroll', onScroll);
    //         }

    //         if (window.wsScroll) attachToScroll(window.wsScroll);
    //         window.addEventListener('ws:locomotive-ready', function(e){
    //             var s = e && e.detail && e.detail.scroll;
    //             attachToScroll(s || window.wsScroll);
    //         }, { once: true });
    //     } catch (e) {}
    // })();

    // Mobile menu toggle for primary navigation
    // Replaced by offcanvas burger menu

    function initModel3DSection(context) {
        var root = context || document;
        var els = root.querySelectorAll('.js-model3d-section__canvas');
        if (!els || !els.length) return;
        els.forEach(function(el){
            if (!el || el.dataset.model3dReady) return;
            el.dataset.model3dReady = '1';
            // Lazy import to avoid bundling heavy three.js into editor unnecessarily
            import(/* @vite-ignore */ './model3d-section.js').then(function(mod){
                if (mod && typeof mod.initModel3DSection === 'function') {
                    mod.initModel3DSection(el);
                }
            }).catch(function(){});
        });
    }

    try { window.wsInitModel3DSectionIn = initModel3DSection; } catch (e) {}
    // Ensure initialization runs even if the block view script fires earlier
    initModel3DSection(document);

    // Floating labels for contact form block
    (function () {
        try {
            var blocks = document.querySelectorAll('.ws-block--contact-form');
            if (!blocks || !blocks.length) return;

            blocks.forEach(function (block) {
                var form = block.querySelector('form');
                if (!form) return;

                var fields = form.querySelectorAll(
                    '.form-group input[type="text"],' +
                    '.form-group input[type="email"],' +
                    '.form-group input[type="tel"],' +
                    '.form-group input[type="number"],' +
                    '.form-group input[type="date"],' +
                    '.form-group input[type="time"],' +
                    '.form-group input[type="url"],' +
                    '.form-group textarea,' +
                    '.form-group .wpcf7-text,' +
                    '.form-group .wpcf7-textarea'
                );

                if (!fields.length) return;

                fields.forEach(function (field) {
                    var group = field.closest('.form-group');
                    if (!group) return;

                    // Mark this group as using floating-label behavior
                    group.classList.add('form-group--floating');

                    function updateFilledState() {
                        var value = (field.value || '').trim();
                        if (value.length > 0) {
                            group.classList.add('form-group--has-value');
                        } else {
                            group.classList.remove('form-group--has-value');
                        }
                    }

                    field.addEventListener('focus', function () {
                        group.classList.add('form-group--is-focused');
                        updateFilledState();
                    });

                    field.addEventListener('blur', function () {
                        group.classList.remove('form-group--is-focused');
                        updateFilledState();
                    });

                    field.addEventListener('input', updateFilledState);

                    // Initialise state on load (for prefilled fields)
                    updateFilledState();
                });
            });
        } catch (e) {}
    })();

    // Volunteer signup popup
    (function () {
        var popup = document.querySelector('[data-ws-signup-popup]');
        if (!popup) return;

        var form = popup.querySelector('[data-ws-signup-form]');
        var info = popup.querySelector('[data-ws-signup-info]');
        var eventText = popup.querySelector('[data-ws-signup-event]');
        var eventInput = popup.querySelector('[data-ws-signup-event-id]');
        var details = popup.querySelector('[data-ws-signup-details]');
        var detailsTitle = popup.querySelector('[data-ws-signup-details-title]');
        var detailsList = popup.querySelector('[data-ws-signup-details-list]');
        var popupTitle = popup.querySelector('#ws-signup-title');
        var defaultTitle = popupTitle ? popupTitle.textContent : '';

        var isLoggedIn = popup.getAttribute('data-is-logged-in') === '1';
        var isVolunteer = popup.getAttribute('data-is-volunteer') === '1';

        function setEvent(eventId, title) {
            if (eventInput) {
                eventInput.value = eventId || '';
            }
            if (eventText) {
                eventText.textContent = title ? ('Wydarzenie: ' + title) : '';
            }
        }

        function setSignupVisibility() {
            if (!form || !info) return;
            if (isLoggedIn && isVolunteer) {
                form.style.display = '';
                info.style.display = 'none';
            } else {
                form.style.display = 'none';
                info.style.display = '';
            }
        }

        function setMode(mode) {
            popup.setAttribute('data-ws-signup-mode', mode);
            popup.classList.toggle('is-details', mode === 'details');
            if (details) {
                details.style.display = mode === 'details' ? '' : 'none';
            }
            if (popupTitle) {
                popupTitle.textContent = mode === 'details' ? (detailsTitle && detailsTitle.textContent ? detailsTitle.textContent : defaultTitle) : defaultTitle;
            }
            if (mode === 'details') {
                if (form) form.style.display = 'none';
                if (info) info.style.display = 'none';
            } else {
                setSignupVisibility();
            }
        }

        function renderDetails(items, title) {
            if (detailsTitle) {
                detailsTitle.textContent = title || '';
            }
            if (!detailsList) return;
            detailsList.innerHTML = '';
            if (!items || !items.length) {
                return;
            }
            items.forEach(function (item) {
                if (!item || !item.value) return;
                var row = document.createElement('div');
                row.className = 'ws-signup-popup__detail';
                var label = document.createElement('span');
                label.className = 'ws-signup-popup__detail-label';
                label.textContent = item.label || '';
                var value = document.createElement('span');
                value.className = 'ws-signup-popup__detail-value';
                value.textContent = item.value;
                row.appendChild(label);
                row.appendChild(value);
                detailsList.appendChild(row);
            });
        }

        function openDetails(trigger) {
            var type = trigger.getAttribute('data-ws-details') || '';
            var title = trigger.getAttribute('data-ws-details-title') || '';
            var items = [];

            if (type === 'event') {
                var date = trigger.getAttribute('data-ws-details-date') || '';
                var time = trigger.getAttribute('data-ws-details-time') || '';
                var place = trigger.getAttribute('data-ws-details-place') || '';
                var content = trigger.getAttribute('data-ws-details-content') || '';
                var organizer = trigger.getAttribute('data-ws-details-organizer') || '';
                var leader = trigger.getAttribute('data-ws-details-leader') || '';
                var seats = trigger.getAttribute('data-ws-details-seats') || '';

                if (date) items.push({ label: 'Data', value: date });
                if (time) items.push({ label: 'Godzina', value: time });
                if (place) items.push({ label: 'Miejsce', value: place });
                if (organizer) items.push({ label: 'Organizator', value: organizer });
                if (leader) items.push({ label: 'Prowadzący', value: leader });
                if (seats) items.push({ label: 'Liczba miejsc', value: seats });
                if (content) items.push({ label: 'Treść', value: content });
            }

            if (type === 'volunteer') {
                var email = trigger.getAttribute('data-ws-details-email') || '';
                var metaRaw = trigger.getAttribute('data-ws-details-meta') || '';
                if (email) items.push({ label: 'Email', value: email });
                if (metaRaw) {
                    try {
                        var metaItems = JSON.parse(metaRaw);
                        if (Array.isArray(metaItems)) {
                            metaItems.forEach(function (entry) {
                                if (!entry || !entry.value) return;
                                var label = entry.label || entry.key || '';
                                if (entry.key && entry.label && entry.key !== entry.label) {
                                    label = entry.label + ' (' + entry.key + ')';
                                }
                                items.push({ label: label, value: entry.value });
                            });
                        }
                    } catch (e) {}
                }
            }

            if (eventText) {
                eventText.textContent = '';
            }
            popup.setAttribute('data-ws-details-type', type);
            renderDetails(items, title);
            setMode('details');
            openPopup();
        }

        function openPopup() {
            popup.classList.add('is-open');
            popup.setAttribute('aria-hidden', 'false');
            popup.classList.toggle('is-volunteer', isLoggedIn && isVolunteer);
        }

        function closePopup() {
            popup.classList.remove('is-open');
            popup.setAttribute('aria-hidden', 'true');
        }

        document.addEventListener('click', function (event) {
            var trigger = event.target && event.target.closest('[data-ws-signup]');
            if (trigger) {
                event.preventDefault();
                setEvent(trigger.getAttribute('data-event-id'), trigger.getAttribute('data-event-title'));
                setMode('signup');
                openPopup();
            }

            var detailsTrigger = event.target && event.target.closest('[data-ws-details]');
            if (detailsTrigger) {
                event.preventDefault();
                openDetails(detailsTrigger);
            }

            if (event.target && event.target.closest('[data-ws-signup-close]')) {
                event.preventDefault();
                closePopup();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closePopup();
            }
        });

        var status = popup.getAttribute('data-signup-status');
        if (status) {
            setEvent(popup.getAttribute('data-event-id'), popup.getAttribute('data-event-title'));
            setMode('signup');
            openPopup();
        }

        setSignupVisibility();
    })();

    // Locomotive Scroll init
    (function(){
        try {
            var container = document.querySelector('[data-scroll-container]');
            if (!container || !window.LocomotiveScroll) return;

            var prefersReducedMotion = false;
            try {
                prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            } catch (e) {}
            var isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0));

            // Do not auto-add data-scroll-section; rely on native markup

            var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            var treatAsDesktop = viewportWidth >= 1024;
            var useSmooth = !prefersReducedMotion && (treatAsDesktop || !isTouch);

            var scroll = new window.LocomotiveScroll({
                el: container,
                smooth: useSmooth,
                lerp: 0.08,
                smartphone: { smooth: false },
                tablet: { smooth: false }
            });

            try { window.wsScroll = scroll; } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent('ws:locomotive-ready', { detail: { scroll: scroll } }));
            } catch (e) {}

            // Remove initial lock class once Locomotive is ready
            try { document.documentElement.classList.remove('is-frontend'); } catch (e) {}

            // Update after images/fonts load
            window.addEventListener('load', function(){
                try { scroll.update(); } catch (e) {}
            });

            // Extra delayed refreshes to catch late layout shifts
            // try { setTimeout(function(){ scroll.update(); }, 120); } catch (e) {}
            // try { setTimeout(function(){ scroll.update(); }, 400); } catch (e) {}
            // try { setTimeout(function(){ scroll.update(); }, 1200); } catch (e) {}

            // Refresh on orientation changes
            window.addEventListener('orientationchange', function(){
                try { setTimeout(function(){ scroll.update(); }, 250); } catch (e) {}
            });

            // Refresh when webfonts are ready
            try {
                if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
                    document.fonts.ready.then(function(){ try { scroll.update(); } catch (e) {} });
                }
            } catch (e) {}

            // Refresh on image loads within the scroll container
            // try {
            //     var imgs = container.querySelectorAll('img');
            //     imgs.forEach(function(img){
            //         if (!img || img.complete) return;
            //         img.addEventListener('load', function(){
            //             try { if (window.wsLocoUpdate) window.wsLocoUpdate(); else scroll.update(); } catch (e) {}
            //         }, { once: true });
            //     });
            // } catch (e) {}

            // Observe DOM and size mutations to keep height in sync
            // try {
            //     if (typeof MutationObserver !== 'undefined') {
            //         var mo = new MutationObserver(function(){
            //             try { if (window.wsLocoUpdate) window.wsLocoUpdate(); else scroll.update(); } catch (e) {}
            //         });
            //         mo.observe(container, { childList: true, subtree: true });
            //     }
            // } catch (e) {}

            try {
                if (typeof ResizeObserver !== 'undefined') {
                    var ro = new ResizeObserver(function(){
                        try { if (window.wsLocoUpdate) window.wsLocoUpdate(); else scroll.update(); } catch (e) {}
                    });
                    ro.observe(container);
                }
            } catch (e) {}

            var resizeTimer;
            window.addEventListener('resize', function(){
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function(){
                    try { scroll.update(); } catch (e) {}
                }, 200);
            });
        } catch (e) {}
    })();
});